export const BINDINGKEYS = {
  RMCONTACT: "rmContact",
  OTHERINFITHEISMCONTACT: "otherInfinitheismContact",
  NOOFHDBS: "no_of_hdbs",
  DOB: "dob",
  NAME: "name",
  GENDER: "gender",
  MOBILE_NUMBER: "mobileNumber",
  EMAIL: "email",
  CITY: "city",
  OTHER_CITY_NAME: "otherCityName",
  PROFILE_URL: "profileUrl",
  GOODIES_NOTEBOOK: 'goodiesNotebook',
  GOODIES_RATRIA_PILLAR_LEONIA: 'goodiesRatriaPillarLeonia',
  GOODIES_FLASK: 'goodiesFlask',
  TERMS: 'terms',
};

export const TYPES = {
  DRAGNDROP: "draganddrop",
};

export const LABELS = {
  UPLOAD_VIDEO: "Upload video",
};

export const profile_binding_keys = {
  name: null,
  gender: null,
  mobileNumber: null,
  email: null,
  dob: null,
  city: null,
  otherCityName: null,
  profileUrl: null,
  no_of_hdbs: null,
};


export const OFFLINE_PENDING = "offline_pending";